












































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import {
  GetTestDetail$,
  GetTestQuestionsList$,
  DeleteQustionsInTest$,
  ChangeFenshu$,
  ComposeTest$,
} from "@/request/jxgl";
import MainHeader from "../../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../components/left-nav.vue";
import AddRandom from "./add-random.vue";
import AddSelect from "./add-select.vue";
import QuestionTable from "./question-table.vue";
import Pagination from "@/components/paginaiton.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    AddRandom,
    AddSelect,
    QuestionTable,
    Pagination,
  },
})
export default class SjkDetail extends Vue {
  private test: any = {
    test_id: "",
    试卷名称: "",
    随机选择: [],
    手动选择: [],
  };
  private filters: any = {
    current_page: 1,
    total_count: 0,
    total_page: 0,
    page_count: 10,
  };
  private selectedMessages: any[] = [];
  private ifShowAddRandom: boolean = false;
  private ifShowAddSelect: boolean = false;
  /**
   * @description 获得试卷详情
   */
  private fetchDetail() {
    const params: any = {
      test_id: this.test.test_id,
      current_page: this.filters["current_page"],
      page_count: this.filters["page_count"],
    };
    GetTestQuestionsList$(this, params).then((data: any) => {
      data.questions.forEach((question: any) => {
        const inc = _.findIndex(this.selectedMessages, (i) => {
          return i["question_id"] === question["question_id"];
        });
        if (inc !== -1) {
          question["selected"] = true;
        } else {
          question["selected"] = false;
        }
        question["isChangingFenshu"] = false;
      });
      this.$set(this, "test", data);
      this.filters.total_count = data.total_count;
      this.filters.total_page = data.total_page;
    });
  }
  /**
   * @description 改变试卷名称
   */
  private changeTestName() {
    if (!this.test["试卷名称"]) {
      this.$message.warning("试卷名称不能为空");
      return;
    }
    const params: any = {
      test_id: this.test["test_id"],
      试卷名称: this.test["试卷名称"],
      随机选择: [{ cate_id: "", count: 0 }],
    };
    ComposeTest$(this, params).then((data: any) => {
      this.$message.success("修改成功");
    });
  }
  /**
   * @description 打开随机添加弹窗
   */
  private openAddRandom() {
    if (!this.test["试卷名称"]) {
      this.$message.warning("试卷名称不能为空");
      return;
    }
    this.ifShowAddRandom = true;
  }
  /**
   * @description 打开手动添加弹窗
   */
  private openAddSelect() {
    if (!this.test["试卷名称"]) {
      this.$message.warning("试卷名称不能为空");
      return;
    }
    this.ifShowAddSelect = true;
  }
  // 取消
  private cancel() {
    this.$router.back();
  }
  // 预览
  private preview() {
    this.$router.push({
      path: "/main/jxgl/sjk-preview",
      query: {
        id: this.test.test_id,
      },
    });
  }
  /**
   * @description 处理试卷获得了id
   */
  private handleTestChange(id) {
    this.test.test_id = id;
    this.filters.current_page = 1;
    this.fetchDetail();
  }
  /**
   * @description 处理页码变化
   */
  private handlePageChange(page) {
    this.filters.current_page = page;
    this.fetchDetail();
  }
  // 选中改变
  private selectChange(value, item) {
    if (item.selected) {
      this.selectedMessages.push(item);
      this.selectedMessages = _.uniqBy(this.selectedMessages, "question_id");
    } else {
      const index = _.findIndex(this.selectedMessages, "question_id");
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 删除一个题目
   */
  private deleteOne(question) {
    const params: any = {
      data: {
        test_id: this.test["test_id"],
        question_ids: [question["question_id"]],
      },
    };
    DeleteQustionsInTest$(this, params).then((data: any) => {
      this.$message.success("删除成功");
      this.selectedMessages = [];
      this.fetchDetail();
    });
  }
  /**
   * @description 批量删除
   */
  private deleteThese() {
    if (this.selectedMessages.length === 0) {
      this.$message.warning("请至少选择一个题目");
      return;
    }
    const arr: any[] = [];
    this.selectedMessages.forEach((question: any) => {
      arr.push(question["question_id"]);
    });
    const params: any = {
      data: {
        test_id: this.test["test_id"],
        question_ids: arr,
      },
    };
    DeleteQustionsInTest$(this, params).then((data: any) => {
      this.$message.success("删除成功");
      this.selectedMessages = [];
      this.filters.current_page = 1;
      this.fetchDetail();
    });
  }
  /**
   * @description 改变分数
   */
  private changeFenshu(focusobj, question) {
    const params: any = {
      test_id: this.test.test_id,
      question_id: question.question_id,
      score: Number(question.score),
    };
    ChangeFenshu$(this, params).then((data: any) => {
      this.fetchDetail();
      this.$message.success("修改成功");
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.$route.query.id) {
      this.test.test_id = this.$route.query.id;
      this.fetchDetail();
    }
  }
}
